import { createSignal } from "solid-js";
import { Temporal } from "temporal-polyfill";

export interface Geolocation {
  latitude: number;
  longitude: number;
}

export interface SessionState {
  /** IANA timezone identifier, e.g. "America/Vancouver" */
  timezone: string;
  geolocation: Geolocation | null;
}

const PEMBERTON_BC: Geolocation = { latitude: 50.3172, longitude: -122.8029 };

const [isLoggedIn, setIsLoggedIn] = createSignal(false);

const [session, setSession] = createSignal<SessionState>({
  timezone: Temporal.Now.timeZoneId(),
  geolocation: null,
});

export { isLoggedIn, session };

export const login = () => {
  setIsLoggedIn(true);
  navigator.geolocation.getCurrentPosition(
    (pos) =>
      setSession((s) => ({
        ...s,
        geolocation: {
          latitude: pos.coords.latitude,
          longitude: pos.coords.longitude,
        },
      })),
    () => setSession((s) => ({ ...s, geolocation: PEMBERTON_BC })),
    { timeout: 10_000, maximumAge: 60_000 },
  );
};

export const logout = () => {
  setIsLoggedIn(false);
  setSession((s) => ({ ...s, geolocation: null }));
};
